module.exports = ".mostrar-ot-option {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  padding: 4px;\n  line-height: 16px; }\n"